import { autoLockRulesApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const AUTO_LOCK_RULES_ACTION_TYPE = createNamedActions('autoLockRules', {
  GET_AUTO_LOCK_RULES: 'GET_AUTO_LOCK_RULES',
  CREATE_AUTO_LOCK_RULE: 'CREATE_AUTO_LOCK_RULE',
  EDIT_AUTO_LOCK_RULE: 'EDIT_AUTO_LOCK_RULE',
  GET_AUTO_LOCK_RULES_SCHEMA: 'GET_AUTO_LOCK_RULES_SCHEMA',
  REORDER_AUTO_LOCK_RULES: 'REORDER_AUTO_LOCK_RULES',
});

export const getAutoLockRulesAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await autoLockRulesApi.getAutoLockRules(params);

  return dispatch({
    type: AUTO_LOCK_RULES_ACTION_TYPE.GET_AUTO_LOCK_RULES,
    payload: data,
  });
});

export const createAutoLockRuleAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await autoLockRulesApi.createAutoLockRule(params);

  return dispatch({
    type: AUTO_LOCK_RULES_ACTION_TYPE.CREATE_AUTO_LOCK_RULE,
    payload: data,
  });
});

export const editAutoLockRuleAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await autoLockRulesApi.editAutoLockRule(params);

  return dispatch({
    type: AUTO_LOCK_RULES_ACTION_TYPE.EDIT_AUTO_LOCK_RULE,
    payload: data,
  });
});

export const deleteAutoLockRuleAction = catchAsyncActionError(params => async dispatch => {
  await autoLockRulesApi.deleteAutoLockRule(params);

  await dispatch(getAutoLockRulesAction());
});

export const getAutoLockRulesSchemaAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await autoLockRulesApi.getAutoLockFieldRulesExpressionDefinition();

  return dispatch({
    type: AUTO_LOCK_RULES_ACTION_TYPE.GET_AUTO_LOCK_RULES_SCHEMA,
    payload: data,
  });
});

export const recalculateAutoLockRulesAction = catchAsyncActionError(() => async dispatch => {
  await autoLockRulesApi.recalculateAutoLockRules();

  await dispatch(getAutoLockRulesAction());
});

const reorderAutoLockRuleOptimistic = params => ({
  type: AUTO_LOCK_RULES_ACTION_TYPE.REORDER_AUTO_LOCK_RULES,
  payload: params,
});

export const reorderAutoLockRuleAction = catchAsyncActionError(params => async dispatch => {
  dispatch(reorderAutoLockRuleOptimistic(params));

  try {
    await autoLockRulesApi.reorderAutoLockRule(params);
  } catch (error) {
    await dispatch(getAutoLockRulesAction());

    throw error;
  }
});
